import React, { useEffect, useRef, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'

import { Sainsburys } from '@sainsburys-tech/luna-images'
import {
  Header,
  HeaderGlobalBar,
  HeaderGlobalItem,
  HeaderLogo,
  HeaderMainBar,
  HeaderNav,
  ListGroup,
  ListGroupItem,
  ListGroupDropdown,
} from '@sainsburys-tech/luna-react'

import SignOutButton from '../SignOutButton'
import Constants from '../../../utils/constants'
import Feedback from '../../Feedback'

interface PageHeaderProps {
  roles: string[]
}

const PageHeader = ({ roles }: PageHeaderProps) => {
  const [width, setWidth] = useState(window.screen.width)
  const path = useLocation().pathname
  const feedback: any = useRef()

  const onResize = () => {
    setWidth(window.screen.width)
  }

  useEffect(() => {
    window.addEventListener('resize', onResize)
    return (() => {
      window.removeEventListener('resize', onResize)
    })
  })

  const handleFeedbackClick = (event: any) => {
    event.preventDefault()
    feedback.current?.show()
  }
  const [activeCEscalation, setActiveCEscalation] = React.useState(false)
  const [activeSCM, setActiveSCM] = React.useState(false)
  const [activeOthers, setActiveOthers] = React.useState(false)
  const [activeWeekendOnCall, setActiveWeekendOnCall] = useState(false)
  const [hover, setHover] = React.useState(false)

  const generateTabs = () => {
    if (roles) {
      if (roles.includes(Constants.AdminRole)) {
        return <HeaderNav drawer label="Main">
          <NavLink className={`blockSiteItem siteItem ${path === '/' && 'active'}`} to='/automationContacts'>Automation Contacts</NavLink>
          <ListGroupDropdown className='siteItem'
            hover={activeCEscalation}
            onMouseEnter={(e: any) => { setActiveCEscalation(true) }}
            onMouseLeave={(e: any) => { setActiveCEscalation(false) }}
            onClose={(e: any) => { setActiveCEscalation(false) }}
            containerClassName='contracts'
          >
            Contractor Contacts
            <ListGroup>
              <ListGroupItem element="a" href="/User">
                User
              </ListGroupItem>
              <ListGroupItem element="a" href="/add-standard-contacts">
                Add Standard Contacts
              </ListGroupItem>
              <ListGroupItem element="a" href="/edit-standard-contacts">
                Edit Standard Contacts
              </ListGroupItem>
              <ListGroupItem element="a" href="/add-weekend">
                Add Weekend On-Call
              </ListGroupItem>
              <ListGroupItem element="a" href="/edit-weekend">
                Edit Weekend On-Call
              </ListGroupItem>
            </ListGroup>
          </ListGroupDropdown>
          <NavLink className='siteItem blockSiteItem' to='/contractor-management'>Contractor Management</NavLink>
          {/* <NavLink className='siteItem' to='/new-contractor'>New Contractor</NavLink> */}
          <ListGroupDropdown className='siteItem'
            hover={activeSCM}
            containerClassName='scm'
            onMouseEnter={(e: any) => { setActiveSCM(true) }}
            onMouseLeave={(e: any) => { setActiveSCM(false) }}
            onClose={(e: any) => { setActiveSCM(false) }}
          >
            Retail and Logistics
            <ListGroup>
              <ListGroupItem element='a' href='/assign-region'>
                Assign Regions
              </ListGroupItem>
              <ListGroupItem element='a' href='/SCMPeopleList'>
                People List
              </ListGroupItem>
              <ListGroupItem element="a" href="/weekendoncall">
                Weekend On-Call Users
              </ListGroupItem>
            </ListGroup>
          </ListGroupDropdown>
          <NavLink className='siteItem blockSiteItem' to='/database-tables'>Database Tables</NavLink>
          <NavLink className='siteItem blockSiteItem' to='/branch-locator'>Branch Locator</NavLink>
          <ListGroupDropdown className='siteItem otherSiteItems'
            hover={activeOthers}
            containerClassName='otherSiteItems'
            onMouseEnter={(e: any) => { setActiveOthers(true) }}
            onMouseLeave={(e: any) => { setActiveOthers(false) }}
            onClose={(e: any) => { setActiveOthers(false) }}
          >
            Others
            <ListGroup>
              <ListGroupItem element='a' href='/automationContacts'>
                Automation Contacts
              </ListGroupItem>
              <ListGroupItem element='a' href='/contractor-management'>
                Contractor Management
              </ListGroupItem>
              <ListGroupItem element='a' href='/database-tables'>
                Database Tables
              </ListGroupItem>
              <ListGroupItem element="a" href="/branch-locator">
                Branch Locator
              </ListGroupItem>
            </ListGroup>
          </ListGroupDropdown>
          <div className='siteItem'>
            <a href="" style={{ textDecoration: 'none' }} onClick={handleFeedbackClick}>Feedback</a>
          </div> 
          {width < 721 ?
            <div className='siteItem'>
              <SignOutButton />
            </div> : <></>
          }
        </HeaderNav>
      }
      else if (roles.includes(Constants.ContractorManagerRole)) {
        return <HeaderNav drawer label="Main">
          <NavLink className={`siteItem ${path === '/' && 'active'}`} to='/automationContacts'>Automation Contacts</NavLink>
          <ListGroupDropdown className='siteItem'
            hover={activeCEscalation}
            onMouseEnter={(e: any) => { setActiveCEscalation(true) }}
            onMouseLeave={(e: any) => { setActiveCEscalation(false) }}
            onClose={(e: any) => { setActiveCEscalation(false) }}
            containerClassName='contracts'
          >
            Contractor Contacts
            <ListGroup>
              <ListGroupItem element="a" href="/User">
                User
              </ListGroupItem>
              <ListGroupItem element="a" href="/add-standard-contacts">
                Add Standard Contacts
              </ListGroupItem>
              <ListGroupItem element="a" href="/edit-standard-contacts">
                Edit Standard Contacts
              </ListGroupItem>
              <ListGroupItem element="a" href="/add-weekend">
                Add Weekend On-Call
              </ListGroupItem>
              <ListGroupItem element="a" href="/edit-weekend">
                Edit Weekend On-Call
              </ListGroupItem>
            </ListGroup>
          </ListGroupDropdown>
          <div className='siteItem'>
            <a href="" style={{ textDecoration: 'none' }} onClick={handleFeedbackClick}>Feedback</a>
          </div>
          {width < 721 ?
            <div className='siteItem'>
              <SignOutButton />
            </div> : <></>
          }
        </HeaderNav>
      }
    }
    else {
      return <HeaderNav drawer label="Main"></HeaderNav>
    }
  }

  return (
    <>
      <Feedback
        ref={feedback}
        headerText={'How was FM Core?'}
        bodyText={'We want to know how you found using FM Core today, so we can learn from your feedback and improve the tools you use.'}
      />
      <Header>
        <HeaderGlobalBar className='sainsbury'>
          <HeaderGlobalItem className='sainsburysItem'>
            <Sainsburys className='sainsburysLogo' aria-label="Sainsbury's logo" />
          </HeaderGlobalItem>
          {/* <HeaderGlobalItem align='right' style={{alignSelf: 'center', fontSize: 'larger'}}>
            <div>
            <a href="" style={{ textDecoration: 'none' }} onClick={handleFeedbackClick}>Feedback</a>
          </div>
          </HeaderGlobalItem> */}
          <HeaderGlobalItem align='right' >
            <SignOutButton />
          </HeaderGlobalItem>
        </HeaderGlobalBar>
        <HeaderMainBar className='headerMainBar'>
          <HeaderLogo className='headerLogo'>
            FM Core
          </HeaderLogo>
          {generateTabs()}
        </HeaderMainBar>
      </Header>
    </>
  )
}

export default PageHeader